import { useMemo, useCallback } from 'react';
import { useAuth } from '@/lib/auth/auth-context';
import { type PermissionString } from '@/lib/constants/permissions';

export function usePermissions() {
  const { activeChannel } = useAuth();

  const permissions = useMemo(
    () => new Set(activeChannel?.permissions ?? []),
    [activeChannel?.permissions]
  );

  const hasPermission = useCallback(
    (p: PermissionString) => {
      return permissions.has('SuperAdmin') || permissions.has(p);
    },
    [permissions]
  );

  const hasAnyPermission = useCallback(
    (perms: PermissionString[]) => {
      return perms.some((p) => hasPermission(p));
    },
    [hasPermission]
  );

  return { hasPermission, hasAnyPermission, permissions };
}
